import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthenticationService } from 'src/app/services/authentication.service';
import * as moment from 'moment';
import { CustomerService } from 'src/app/services/customer.service';
@Component({
  selector: 'app-ar-customer-invoice',
  templateUrl: './ar-customer-invoice.component.html',
  styleUrls: ['./ar-customer-invoice.component.scss']
})
export class ArCustomerInvoiceComponent implements OnInit {


  reservationID;
  invoiceData = [];
  miscServices = [];
  passengers = [];
  flightInfo = [];
  activeTab;
  private notifier: NotifierService;
  constructor(private spinner: NgxSpinnerService,
    notifierService: NotifierService,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthenticationService,
    private arCustomerService: CustomerService) {
    this.notifier = notifierService;
    this.activeTab = this.route.snapshot.params.tid;
  }

  ngOnInit() {
    this.reservationID = this.route.snapshot.paramMap.get('id');
    localStorage.setItem('arCTActiveTab', this.activeTab);
    if (this.reservationID == '' || null) {
      this.onBack();
    }
    this.getAllInvoiceData();

  }

  subTotal = 0;
  getAllInvoiceData() {
    this.subTotal = 0;
    this.spinner.show();
    this.arCustomerService.customerInvoiceInfo(this.reservationID).subscribe(async res => {
      this.spinner.hide();
      if (res['status']) {
        // this.notifier.notify('success', 'Payment method successfully submitted.');
        //  this.submitCCType = true;
        this.invoiceData = res['result'].invoice;
        this.miscServices = res['result'].miscService;
        this.flightInfo = res['result'].flight;
        this.passengers = res['result'].passenger;
        // console.log(res);
        // setTimeout(r => {
        //   this.router.navigateByUrl("home/ar-dashboard");
        // },3000)

        for (let j of res['result'].miscService) {
          this.subTotal += (parseFloat(j.AMOUNT) * j.QUANTITY);

        }
        // console.log(this.subTotal, "SubTotal");

      } else {
        // this.notifier.notify('danger', 'Payment method Failed');
      }
    }, err => {
      this.spinner.hide();
      this.notifier.notify('danger', err.message)
      console.log(err);
    })
  }

  onBack() {
    this.router.navigateByUrl("home/customer-dashboard");
  }
  saveInvoicePrint() {
    // console.log('Calling....');
    const invoiceObj = {
      RESID: this.reservationID,
      PRINTED: 1,
      PRINTED_BY: this.authService.getCurrentUserId()
    }
    this.arCustomerService.updatePrintOfInvoice(invoiceObj).subscribe(async res => {
      if (res['status']) {
        //console.log(res['status']);
      } else {
        // console.log(res['message']);
      }
    }, err => {

      console.log(err);
    })
  }


  getTime(date) {
    return moment.utc(date).format('MMM DD, YYYY HH:mm')
  }

  getDate(date) {
    return moment.utc(date).format('MMM DD, YYYY')
  }

  getTimeFormat(date) {
    if (date == null) {
      return '';
    }
    return moment.utc(date).format('MM/DD/YY, hh:mm a');
  }
  getDateFormat(date) {
    return moment.utc(date).format('MM/DD/YY');
  }


}
